
import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'

import {
  C,
  logg,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import { ReportsCtx } from '$src/components/reports'

/**
 * PdfModal
**/
const PdfModal = (props) => {
  // logg(props, 'PdfModal')
  const {
    fontSize, setFontSize,
    itemsPerRow, setItemsPerRow,
    portraitNotLandscape, setPortraitNotLandscape,
  } = props

  /* ctx */

  const {
    pdfModalOpen, setPdfModalOpen,
  } = useContext(ReportsCtx)
  // logg(useContext(ReportsCtx), 'ReportsCtx in PdfModal')

  /* methods */

  const handleSave = () => {}

  return <Modal
    ariaHideApp={false}
    className="BaseModal PdfModal "
    isOpen={pdfModalOpen}
    onRequestClose={ () => setPdfModalOpen(false) }
    overlayClassName="PdfModalOverlay"
  >
    <div className='header'>
      <h5 >PDF settings</h5>
      <div className='close' onClick={() => setPdfModalOpen(false)}>&times;</div>
    </div>

    <div className='container mb-3'>
      <div className='row mt-3'>
        <div className='col-md-2'></div>
        <div className='col-md-8'>
          <div className='field no-mb'>
            <label>Portrait</label>
            {/* <Checkbox checked={portraitNotLandscape} onChange={(ev) => setPortraitNotLandscape(ev.target.checked) }/> */}
            <input type='radio' name="portraitNotLandscape" value={true} checked={portraitNotLandscape === "true"}
              onChange={(ev) => setPortraitNotLandscape(ev.target.value) } />
          </div>
          <div className='field'>
            <label>Landscape</label>
            <input type='radio' name="portraitNotLandscape" value={false} checked={portraitNotLandscape === "false"}
              onChange={(ev) => setPortraitNotLandscape(ev.target.value) } />
          </div>
          <div className='field'>
            <label>Font Size</label>
            <Select className='select2'
              isSearchable={false}
              menuPlacement={'bottom'}
              onChange={(ev) => setFontSize(ev.value) }
              options={C.fontSizeOpts}
              style={C.select2Styles}
              value={C.fontSizeOpts.filter(e => e.value === fontSize)}
            />
          </div>
          <div className='field'>
            <label>Items per row</label>
            <Select className='select2'
              isSearchable={false}
              menuPlacement={'bottom'}
              onChange={(ev) => setItemsPerRow(ev.value) }
              options={C.itemsPerRowOpts}
              style={C.select2Styles}
              value={C.itemsPerRowOpts.filter(e => e.value === itemsPerRow)}
            />
          </div>
        </div>
      </div>
    </div>

    {/* <div className='actions'>
      <div className='left'></div>
      <div className='right'>
        <div className='Btn' onClick={handleSave} >Save</div>
      </div>
    </div> */}

  </Modal>
}
export default PdfModal
